/**
 * @file 
 */
'use strict'

/**
 * @classname Preview
 * @classdesc 管理側のプレビューモード
 */
export default class Preview {
	/**
	 * @constructor
	 * @param {jQuery} $e - 該当する jQuery オブジェクト
	 */
	constructor($e, controller) {
		console.log('Preview.constructor')
		this._$e = $e
		this._$e.prepend('<meta name="robots" content="noindex, nofollow">')
		
		const anchors = $e.find('a')
		anchors.each((index, el) => {
			console.log('a::' + index)
			const $el = $(el)
			if($el.hasClass('canPreview')) return
			$el.prop('href', 'javascript:void(0);')
			$el.prop('target', '')
		})
	}
}
